import config from '../configs/config';

/**
 * Colors Enum
 * @type {Object}
 */
export const COLORS = {
    none: 'background: white; color: white',
    log: 'background: black; color: white',
    error: 'background: #F20404; color: white',
    warn: 'background: orange; color: white',
    info: 'background: #03A9F4; color: white',
    debug: 'background: #4CAF50; color: white',
    verbose: 'background: #333333; color: white'
};

/**
 * Levels Enum
 * @type {Object}
 */
export const LEVELS = {
    none: 0,
    log: 1,
    error: 2,
    warn: 3,
    info: 4,
    debug: 5,
    verbose: 6
};

const BROWSER_CONSOLE_LEVEL_ALIASES = {
    verbose: 'debug'
};

/**
 * Get the color schema for a target logging level
 * @param  {String} level Target logging level
 * @return {String}       Color schema
 */
function getColor(level) {
    return COLORS[level];
}

/**
 * Get the value for a target logging level
 * @param  {String} level Target logging level
 * @return {Number}       Level value
 */
function getLevel(level) {
    return LEVELS[level];
}

/**
 * Try to return a console level that will work in the browser
 * @param  {String} level the logger level name
 * @return {String}       a logger level name that should work in the browser
 */
function getBrowserCompliantLevel(level) {
    return BROWSER_CONSOLE_LEVEL_ALIASES[level] ? BROWSER_CONSOLE_LEVEL_ALIASES[level] : level;
}

/**
 * Create a logger for a target logging level
 * @param  {String} level Target logging level
 * @return {Function}       Logger
 */
function createLogger(level) {
    if (getLevel(config.log.level) >= getLevel(level)) {
        if (typeof console[level] !== 'function') {
            console[level] = console[getBrowserCompliantLevel(level)];
        }

        return console[level].bind(console, '%c[A15]', getColor(level));
    }

    return function noLog() {};
}

export function isDebug() {
    return getLevel(config.log.level) >= getLevel('debug');
}

export function isVerbose() {
    return getLevel(config.log.level) >= getLevel('verbose');
}

export const log = createLogger('log');
export const error = createLogger('error');
export const warn = createLogger('warn');
export const info = createLogger('info');
export const debug = createLogger('debug');
export const verbose = createLogger('verbose');
